const searchRequest = {
	search: {
		query: {
			string: '',
		},
		subQuery: '',
	},
	filters: [],
	sorts: [],
	pagination: {
		page: 1,
		pageSize: 30,
	},
	facets: {
		exclude: [],
		include: [],
	},
	merchandising: {
		disabled: false,
		segments: [],
		landingPage: '',
	},
	tracking: {
		loggedInUserId: 'explorer@athoscommerce.com',
	},
};

const autocompleteRequest = {
	suggestions: {
		count: 5,
	},
	...searchRequest,
	search: {
		query: {
			string: '',
			spellCorrection: true,
		},
		subQuery: '',
	},
	facets: {
		exclude: [],
		include: [],
		limit: 10,
		valueLimit: 5,
	},
};

const globals = {
	siteId: 'your-site-id',
};

export const defaults = {
	autocompleteRequest: JSON.stringify(autocompleteRequest, null, 2),
	searchRequest: JSON.stringify(searchRequest, null, 2),
	globals: JSON.stringify(globals, null, 2),
};
